"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4454],{

/***/ 44367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ zendesk_form; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/base-form/base-form.js + 5 modules
var base_form = __webpack_require__(17784);
// EXTERNAL MODULE: ./client/services/zendesk-service/zendesk-inputs.js
var zendesk_inputs = __webpack_require__(30257);
;// CONCATENATED MODULE: ./segments/desktop/core-components/zendesk-form/default-props.js
/* harmony default export */ var default_props = ({});

// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
// EXTERNAL MODULE: ./constants/cookies.js
var cookies = __webpack_require__(13019);
;// CONCATENATED MODULE: ./client/services/zendesk-service/zendesk-service.js

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var WEBSITE_CREATE_ZENDESK_ENDPOINT = "/dynamic/zendesk/create-ticket";
var getZendeskTicketParams = function(formData) {
    var email = formData[zendesk_inputs/* ZENDESK_EMAIL_INPUT_NAME */.Hw];
    var name = "".concat(formData[zendesk_inputs/* ZENDESK_FIRST_NAME_INPUT_NAME */.dl], " ").concat(formData[zendesk_inputs/* ZENDESK_LAST_NAME_INPUT_NAME */.bd]);
    var subject = formData[zendesk_inputs/* ZENDESK_TICKET_SUBJECT_NAME */.LI];
    var phone = formData[zendesk_inputs/* ZENDESK_PHONE_NUM_INPUT_NAME */.QA];
    var companySize = formData[zendesk_inputs/* ZENDESK_COMPANY_SIZE_INPUT_NAME */.tH];
    var message = formData[zendesk_inputs/* ZENDESK_TICKET_DESCRIPTION_NAME */.vu];
    var contactConsent = formData[zendesk_inputs/* ZENDESK_TICKET_CONTACT_CONSENT_CHECKBOX_NAME */.r_];
    var topic = (0,zendesk_inputs/* getTopicZendeskValue */.xU)(formData[zendesk_inputs/* ZENDESK_TOPIC_INPUT_NAME */.kE]);
    var vid = (0,cookies_service/* getCookie */.ej)(cookies.BIG_BRAIN_VISITOR_ID);
    var uid = (0,cookies_service/* getCookie */.ej)(cookies.MONDAY_PLATFORM_USER_ID);
    var aid = (0,cookies_service/* getCookie */.ej)(cookies.MONDAY_PLATFORM_ACCOUNT_ID);
    return {
        email: email,
        name: name,
        subject: subject,
        phone: phone,
        companySize: companySize,
        message: message,
        contactConsent: contactConsent,
        vid: vid,
        uid: uid,
        aid: aid,
        topic: topic
    };
};
var createZendeskTicket = function() {
    var _ref = _async_to_generator(function(formData) {
        var params, request, response, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = getZendeskTicketParams(formData);
                    return [
                        4,
                        fetch(WEBSITE_CREATE_ZENDESK_ENDPOINT, {
                            method: "POST",
                            body: JSON.stringify({
                                params: params
                            }),
                            headers: {
                                "content-type": "application/json"
                            }
                        })
                    ];
                case 1:
                    request = _state.sent();
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        request.json()
                    ];
                case 3:
                    response = _state.sent();
                    return [
                        2,
                        {
                            success: response.success,
                            message: response.message
                        }
                    ];
                case 4:
                    e = _state.sent();
                    return [
                        2,
                        {
                            success: false
                        }
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function createZendeskTicket(formData) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
;// CONCATENATED MODULE: ./segments/desktop/core-components/zendesk-form/zendesk-form.js







function zendesk_form_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function zendesk_form_async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                zendesk_form_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                zendesk_form_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}









var SUBMIT_ASSET_SRC = "/static/img/forms/cs_representative.png";
var ZendeskForm = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ZendeskForm, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ZendeskForm);
    function ZendeskForm() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, ZendeskForm);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "normalizeFormData", function(formData) {
            var normalizedData = {};
            formData.forEach(function(fieldData) {
                normalizedData[fieldData.name] = fieldData.value;
            });
            return normalizedData;
        });
        var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "sendFormToZendesk", function() {
            var _ref = zendesk_form_async_to_generator(function(formData) {
                var normalizedFormData, companySize, topic, responseData, success, errorMessage;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            normalizedFormData = _this1.normalizeFormData(formData);
                            companySize = normalizedFormData[zendesk_inputs/* ZENDESK_COMPANY_SIZE_INPUT_NAME */.tH];
                            topic = normalizedFormData[zendesk_inputs/* ZENDESK_TOPIC_INPUT_NAME */.kE];
                            BigBrain("track", bigbrain_event_types.ZENDESK_FORM_SUBMIT_CLICKED, {
                                kind: topic,
                                info1: companySize
                            });
                            return [
                                4,
                                createZendeskTicket(normalizedFormData)
                            ];
                        case 1:
                            responseData = _state.sent();
                            success = responseData === null || responseData === void 0 ? void 0 : responseData.success;
                            errorMessage = null;
                            if (responseData === null || responseData === void 0 ? void 0 : responseData.success) {
                                BigBrain("track", bigbrain_event_types.ZENDESK_FORM_SUBMIT_SUCCESS, {
                                    kind: topic,
                                    info1: companySize
                                });
                            } else {
                                errorMessage = responseData === null || responseData === void 0 ? void 0 : responseData.message;
                                BigBrain("track", bigbrain_event_types.ZENDESK_FORM_SUBMIT_FAILED, {
                                    kind: errorMessage
                                });
                            }
                            return [
                                2,
                                {
                                    success: success,
                                    errorMessage: errorMessage
                                }
                            ];
                    }
                });
            });
            return function(formData) {
                return _ref.apply(this, arguments);
            };
        }());
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getKnowledgeBaseLinkHTML", function() {
            var translate = _this.props.translate;
            return '<a href="'.concat(links/* HELP_CENTER_LINK */.j3e, '" target="_blank">\n      ').concat(translate("forms.thanksPage.KnowledgeBase"), "</a>");
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(ZendeskForm, [
        {
            key: "render",
            value: function render() {
                var formConfig = (0,zendesk_inputs/* getZendeskFormConfig */.io)();
                var submitScreenData = {
                    subTitleHtmlKey: "forms.zendesk.thanksPage.subTitle",
                    postSubmitAssetSrc: SUBMIT_ASSET_SRC,
                    footerLinkHtml: this.getKnowledgeBaseLinkHTML()
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "hubspot-contact-form-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_form/* default */.Z, {
                        formConfig: formConfig,
                        submitFormAsyncCallback: this.sendFormToZendesk,
                        renderPrivacyNotice: true,
                        submitScreenData: submitScreenData
                    })
                });
            }
        }
    ]);
    return ZendeskForm;
}(react.PureComponent);
/* harmony default export */ var zendesk_form = ((0,generic_config_context/* withGenericConfig */.P)(ZendeskForm));
ZendeskForm.defaultProps = default_props;


/***/ }),

/***/ 84454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ZendeskSideBySideFormComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/zendesk-form/zendesk-form.js + 2 modules
var zendesk_form = __webpack_require__(44367);
// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/side-by-side-text-and-asset.js
var side_by_side_text_and_asset = __webpack_require__(59526);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/form/layouts/zendesk-side-by-side-form/zendesk-side-by-side-form-component.scss.js


var StyledZendeskSideBySideFormComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e2gds6c0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;");

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/zendesk-side-by-side-form/zendesk-side-by-side-form-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}





var ZendeskSideBySideFormComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ZendeskSideBySideFormComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ZendeskSideBySideFormComponent);
    function ZendeskSideBySideFormComponent() {
        (0,_class_call_check/* default */.Z)(this, ZendeskSideBySideFormComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(ZendeskSideBySideFormComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledZendeskSideBySideFormComponent, {
                    className: "zendesk-side-by-side-form-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(side_by_side_text_and_asset/* default */.Z, _object_spread({
                        replaceTextComponent: zendesk_form/* default */.Z
                    }, this.props))
                });
            }
        }
    ]);
    return ZendeskSideBySideFormComponent;
}(react.PureComponent);

ZendeskSideBySideFormComponent.defaultProps = {
    asset: {
        position: "center",
        fitToContainer: true,
        image: {
            src: "/static/img/segment-layout-default-images/sales_social.png"
        }
    }
};


/***/ })

}]);